'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modal = require('antd/lib/modal');

var _modal2 = _interopRequireDefault(_modal);

var _spin = require('antd/lib/spin');

var _spin2 = _interopRequireDefault(_spin);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('antd/lib/modal/style');

require('antd/lib/spin/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../');

var _ModalLayout = require('../layouts/ModalLayout');

var _ModalLayout2 = _interopRequireDefault(_ModalLayout);

var _style = require('./style.less');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalFormComponent = function (_Component) {
  _inherits(ModalFormComponent, _Component);

  function ModalFormComponent(props) {
    _classCallCheck(this, ModalFormComponent);

    var _this = _possibleConstructorReturn(this, (ModalFormComponent.__proto__ || Object.getPrototypeOf(ModalFormComponent)).call(this, props));

    _this.setLoading = function (value) {
      _this.setState({ isLoading: value });
    };

    _this.state = {
      isLoading: true
    };
    return _this;
  }

  _createClass(ModalFormComponent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.visible !== nextProps.visible) {
        this.setState({ isLoading: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          visible = _props.visible,
          modelName = _props.modelName,
          form = _props.form,
          fetchForm = _props.fetchForm,
          formIsLoading = _props.formIsLoading,
          data = _props.data,
          dataParams = _props.dataParams,
          fetchData = _props.fetchData,
          dataIsLoading = _props.dataIsLoading,
          submitAction = _props.submitAction,
          onCancel = _props.onCancel,
          afterSubmit = _props.afterSubmit,
          url = _props.url,
          error = _props.error,
          errorMessage = _props.errorMessage,
          restProps = _objectWithoutProperties(_props, ['title', 'visible', 'modelName', 'form', 'fetchForm', 'formIsLoading', 'data', 'dataParams', 'fetchData', 'dataIsLoading', 'submitAction', 'onCancel', 'afterSubmit', 'url', 'error', 'errorMessage']);

      return _react2.default.createElement(
        _modal2.default,
        Object.assign({
          title: title,
          width: 1200,
          visible: visible,
          footer: false,
          className: _style2.default.otModalForm,
          maskClosable: false,
          onCancel: onCancel
        }, restProps),
        _react2.default.createElement(
          _ModalLayout2.default,
          null,
          visible ? _react2.default.createElement(
            _spin2.default,
            { spinning: formIsLoading || dataIsLoading || this.state.isLoading },
            _react2.default.createElement(_.Form, {
              modelName: modelName,
              isLoading: this.state.isLoading,
              setLoading: this.setLoading,
              form: form,
              fetchForm: fetchForm,
              formIsLoading: formIsLoading,
              data: data,
              dataParams: dataParams,
              fetchData: fetchData,
              dataIsLoading: dataIsLoading,
              submitAction: submitAction,
              onCancel: onCancel,
              afterSubmit: afterSubmit,
              url: url,
              error: error,
              errorMessage: errorMessage
            })
          ) : null
        )
      );
    }
  }]);

  return ModalFormComponent;
}(_react.Component);

ModalFormComponent.defaultProps = {
  error: undefined,
  errorMessage: '',
  title: '',
  form: undefined,
  formIsLoading: undefined,
  data: undefined,
  fetchData: undefined,
  dataParams: undefined,
  dataIsLoading: undefined,
  afterSubmit: undefined,
  url: ''
};

ModalFormComponent.propTypes = {
  error: _propTypes2.default.bool,
  errorMessage: _propTypes2.default.string,
  title: _propTypes2.default.string,
  visible: _propTypes2.default.bool.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  form: _propTypes2.default.object,
  fetchForm: _propTypes2.default.func.isRequired,
  formIsLoading: _propTypes2.default.bool,
  modelName: _propTypes2.default.string.isRequired,
  data: _propTypes2.default.object,
  fetchData: _propTypes2.default.func,
  dataIsLoading: _propTypes2.default.bool,
  dataParams: _propTypes2.default.object,
  submitAction: _propTypes2.default.func.isRequired,
  afterSubmit: _propTypes2.default.func,
  url: _propTypes2.default.string
};

exports.default = ModalFormComponent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/ModalForm/index.js
// module id = 1033
// module chunks = 0